import Params                from "dashboard/dist/Core/Params";
import { setSection }        from "Actions/Core/CoreActions";
import { ProgramSpeciality } from "Utils/API";

// Types
import {
    PROGRAM_SPECIALITY, PROGRAM_SPECIALITY_LOADING,
    PROGRAM_SPECIALITY_LIST, PROGRAM_SPECIALITY_ELEM, PROGRAM_SPECIALITY_CREATE,
} from "Utils/Types";



/**
 * Fetches the Program Speciality List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSpecialities(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : PROGRAM_SPECIALITY_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "PROGRAM":
            params.programID = elemID;
            data = await ProgramSpeciality.getAllForProgram(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : PROGRAM_SPECIALITY_LIST, data });
        dispatch(setSection(PROGRAM_SPECIALITY));
    };
}

/**
 * Fetches a single Program Speciality
 * @param {Number} programSpecialityID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSpeciality(programSpecialityID) {
    return async (dispatch) => {
        const data = await ProgramSpeciality.getOne({ programSpecialityID });
        dispatch({ type : PROGRAM_SPECIALITY_ELEM, data });
    };
}

/**
 * Fetches the Program Speciality Create data
 * @param {Number} programID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSpecialityCreate(programID) {
    return async (dispatch) => {
        const data = await ProgramSpeciality.getCreateData({ programID });
        dispatch({ type : PROGRAM_SPECIALITY_CREATE, data });
    };
}



/**
 * Edits/Creates a Program Speciality
 * @param {Object} data
 * @returns {() => Void}
 */
export function editSpeciality(data) {
    return () => ProgramSpeciality.edit(data);
}

/**
 * Deletes a Program Speciality
 * @param {Number} programSpecialityID
 * @returns {() => Void}
 */
export function deleteSpeciality(programSpecialityID) {
    return () => ProgramSpeciality.delete({ programSpecialityID });
}
